import { GET_PARAMS } from "./paramHelper";
export const RECEIVE_FILE_PREVIEW = "RECEIVE_FILE_PREVIEW";
export const FILE_PREVIEW_ERROR = "FILE_PREVIEW_ERROR";

export const fetchFilePreview = (reportId, day) => async dispatch => {
  const path = `/api/progress/preview/${reportId}/${day}`;
  try {
    const response = await await fetch(path, GET_PARAMS());

    if (!response.ok) {
      const json = await response.json();
      throw new Error(json.error);
    }

    const { rows } = await response.json();

    return dispatch({
      type: RECEIVE_FILE_PREVIEW,
      rows
    });
  } catch (error) {
    return dispatch({ type: FILE_PREVIEW_ERROR, error: error.message });
  }
};
